import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, isRef as _isRef, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gateway/sel_nav_type.svg'


const _withScopeId = n => (_pushScopeId("data-v-510670f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav_mode" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "导航样式", -1))
const _hoisted_3 = { class: "flex wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "sel_icon",
  src: _imports_0
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "content_set padding" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "标题设置：最多限制为4个字，超出后隐藏", -1))
const _hoisted_10 = { class: "flex between" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable" }, "标题：", -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "padding radio_box" }
const _hoisted_14 = { class: "lable" }
const _hoisted_15 = { class: "set_info" }
const _hoisted_16 = {
  key: 0,
  class: "flex between"
}
const _hoisted_17 = {
  key: 1,
  class: "flex between"
}
const _hoisted_18 = { class: "default_color flex between" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自定义背景色：", -1))
const _hoisted_22 = { class: "set_color flex between" }
const _hoisted_23 = { class: "title_color" }
const _hoisted_24 = {
  key: 1,
  class: "content_set padding"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "标题设置：最多限制为4个字，超出后隐藏", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable" }, "标题：", -1))
const _hoisted_27 = { class: "style_set" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable" }, "标题颜色：", -1))
const _hoisted_29 = { class: "set_info border_top flex" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "颜色：", -1))
const _hoisted_31 = { class: "set_color flex between" }
const _hoisted_32 = { class: "title_color" }
const _hoisted_33 = { class: "border_style border_top" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lable" }, "边框样式", -1))
const _hoisted_35 = { class: "flex padding" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "contentModal_content" }
const _hoisted_38 = { class: "contentModal_content_line" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "链接方式：", -1))
const _hoisted_40 = {
  key: 0,
  class: "contentModal_content_line"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "页"),
  /*#__PURE__*/_createTextVNode(" 面： ")
], -1))
const _hoisted_42 = {
  key: 1,
  class: "contentModal_content_line"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "内"),
  /*#__PURE__*/_createTextVNode(" 容： ")
], -1))
const _hoisted_44 = {
  key: 2,
  class: "contentModal_content_line"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_title" }, "外部链接：", -1))

import { ref, watch } from 'vue';
import { Tabs, Radio, Upload, message, Modal } from 'ant-design-vue';
import { ElColorPicker } from 'element-plus';
import emitter from '@/utils/mitt';
import CIconModal from '@/views/gateway/cubNav/iconModal.vue';
import { getToken } from '@/plugins/cookie';
import http from '@/api/conentCenter/portalDecoration';
import https from '@/api/conentCenter/communal';
import { colorList, uploadNow } from './PublicFunction';
import { useRoute } from 'vue-router';
interface Item {
  title: string;
  title_type: boolean;
  bg_color: string;
  jump_link: string;
  icon?: string;
  bg_img?: string;
  icon_type?: number;
  bg_type?: number;
  jump_type?: number;
}
interface type {
  type: number;
  img_url: string;
  info: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'cubeNav_setup',
  props: {
  custom: {},
},
  setup(__props) {

const props: any = __props;

const route = useRoute();
const gatewayId = route.params.gatewayId;
const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aUpload = Upload;
const aModal = Modal;
const token = getToken();
const navList: any = ref([]);
const content: any = ref({});

props.custom.navList.length > 0 ? (navList.value = [...props.custom.navList]) : '';
content.value = { ...props.custom.content };

/**
 * 立即上传
 */
const { fileList, flieLink, beforeUpload, handleChange } = uploadNow();
watch(
  () => flieLink.value,
  () => {
    setType.value == 'icon' ? (currentItem.value.icon = flieLink.value) : (currentItem.value.bg_img = flieLink.value);
    toVisualization();
  }
);
/** */

const currentItem = ref<Item>({
  title: '',
  title_type: false,
  bg_color: '',
  jump_link: '',
});

const activeKey = ref(1);

const navTemplate = ref<type[]>([]);

const radios = ref([
  {
    lable: '默认',
    value: 0,
  },
  {
    lable: '隐藏',
    value: 1,
  },
  {
    lable: '自定义',
    value: 2,
  },
]);

const setting = ref([
  {
    type: 'icon',
    lable: '图标',
    value: 0,
    radios: radios.value,
  },
  {
    type: 'bg',
    lable: '背景',
    value: 0,
    radios: radios.value,
  },
  {
    type: 'jump',
    lable: '跳转',
    value: 0,
    radios: [
      {
        lable: '不跳转',
        value: 0,
      },
      {
        lable: '自定义',
        value: 1,
      },
    ],
  },
]);

const radiusType = ref([
  {
    type: 0,
    lable: '圆形',
  },
  {
    type: 1,
    lable: '圆角矩形',
  },
  {
    type: 2,
    lable: '正方形',
  },
  {
    type: 3,
    lable: '矩形',
  },
]);

// 单个索引 7为全部
const activeNavItem = ref(7);
emitter.on('selectNavItem', (e: any) => {
  activeNavItem.value = e;
  let obj = {
    jump: 0, //0站内，1站外
    insideLink: undefined,
    inSpecificLink: undefined,
    outsideLink: '',
  };
  if (e != 7) {
    currentItem.value = navList.value[e];
    setting.value[0].value = navList.value[e].icon_type;
    setting.value[1].value = navList.value[e].bg_type;
    setting.value[2].value = navList.value[e].jump_type;
    contentSet.value = navList.value[e].jump ? navList.value[e].jump : obj;
  }
});

const changeContent = (mode: any, type: number, item: any) => {
  toVisualization();
  if (content.value.navType == type) return;
  content.value.navType = type;
  switch (mode) {
    case 'navMode':
      emitter.emit('changeNavType', 7);
      navList.value = item.info;
      content.value.navType == 5
        ? navList.value.length < 6 && navList.value.splice(2, 0, {})
        : navList.value.length > 5 && navList.value.splice(2, 1);
      navList.value.forEach((i: any, j: number) => {
        i.icon_type = i.bg_type = i.jump_type = 0;
        i.title_type = false;
        i.default_bg_color = item.info[j].bg_color;
        i.bg_img = i.jump_link = '';
      });
      if (content.value.navType == 4 || content.value.navType == 5) {
        content.value.title_color = '#fff';
        content.value.radius_type == 0 || content.value.radius_type == 2 ? (content.value.radius_type = 1) : '';
      } else {
        content.value.title_color = '#505D6F';
      }
      break;
    case 'title_color':
      if (content.value.title_type == 0) {
        content.value.navType == 4 || content.value.navType == 5
          ? (content.value.title_color = '#fff')
          : (content.value.title_color = '#505D6F');
      }
      break;
  }
  changeList();
};

const toVisualization = () => {
  const custom = { ...props.custom };
  custom.navList = [...navList.value];
  custom.content = { ...content.value };
  emitter.emit('visualization', custom);
};

const changeList = () => {
  toVisualization();
};
const radioChange = (type: string, status: number) => {
  currentItem.value[type + '_type'] = status;
  changeList();
};

const iconVisible = ref<boolean>(false);
const iconModal = ref();
const onClose = () => {
  iconVisible.value = !iconVisible.value;
};

const iconOrBg = ref();
emitter.on('selectIconOrBg', (e: any) => {
  iconOrBg.value = e;
});

const onOK = () => {
  if (!iconOrBg.value) {
    iconVisible.value = false;
  } else if (iconOrBg.value.length > 1) {
    message.error('请勾选一个' + iconTips.value + '添加');
  } else {
    iconVisible.value = !iconVisible.value;
    iconTips.value == '图标' ? (currentItem.value.icon = iconOrBg.value[0]) : (currentItem.value.bg_img = iconOrBg.value[0]);
  }
};
const iconTips = ref();
const openModal = (type: string) => {
  type == 'icon' ? (iconTips.value = '图标') : (iconTips.value = '背景');
  emitter.emit('iconTips', iconTips.value);
  iconVisible.value = true;
};
const setType = ref();

const getNavigationStyle = () => {
  http.get_navigation_style({}).then((res) => {
    navTemplate.value = res.data.data;
  });
};
getNavigationStyle();

// 链接设置
const linkModal = ref(false);
const openLink = () => {
  linkModal.value = true;
  getSitePageLinks();
};
const choiceOptions = ref([
  {
    value: 0,
    label: '站内页面',
  },
  {
    value: 1,
    label: '外部链接',
  },
]);
const pageOptions = ref([
  { value: 1, label: '文章' },
  { value: 2, label: '图片' },
  { value: 3, label: '直播' },
  { value: 4, label: '文档' },
  { value: 5, label: '文章分类' },
  { value: 6, label: '图片分类' },
  { value: 7, label: '直播分类' },
  { value: 8, label: '文档分类' },
]);
const sitePageLinks = ref();
const getInsideLink = () => {
  contentSet.value.inSpecificLink = undefined;
  getSitePageLinks();
};
const getSitePageLinks = () => {
  const data = {
    portal_id: gatewayId,
    type: contentSet.value.insideLink || 1,
  };
  https.getSitePageLinks({ params: data }).then((res) => {
    sitePageLinks.value = [...res.data.data];
  });
};

const contentSet = ref();
const modalOk = () => {
  navList.value[activeNavItem.value].jump = contentSet.value;
  contentSet.value.jump == 0 && sitePageLinks.value.length != 0
    ? (navList.value[activeNavItem.value].jump_link = sitePageLinks.value.filter(
        (e) => e.id == navList.value[activeNavItem.value].jump.inSpecificLink
      )[0].name)
    : (navList.value[activeNavItem.value].jump_link = contentSet.value.outsideLink);
  linkModal.value = false;
  toVisualization();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "iconModal",
    ref: iconModal
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navTemplate.value, (i, j) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["mode flex center", { active: content.value.navType == i.type }]),
            onClick: ($event: any) => (changeContent('navMode', i.type, i)),
            key: j
          }, [
            _createElementVNode("img", {
              src: i.img_url,
              alt: ""
            }, null, 8, _hoisted_5),
            _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
              [_vShow, content.value.navType == i.type]
            ])
          ], 10, _hoisted_4))
        }), 128))
      ])
    ]),
    _createVNode(_unref(aTabs), {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[13] || (_cache[13] = ($event: any) => ((activeKey).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_unref(aTabPane), {
          key: 1,
          tab: "内容设置"
        }, {
          default: _withCtx(() => [
            (activeNavItem.value != 7)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        _hoisted_11,
                        _createVNode(_component_a_input, {
                          value: currentItem.value.title,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((currentItem.value.title) = $event)),
                          placeholder: "请输入内容",
                          style: {"width":"180px"},
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (changeList()))
                        }, null, 8, ["value"])
                      ]),
                      _createVNode(_component_a_checkbox, {
                        checked: currentItem.value.title_type,
                        "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((currentItem.value.title_type) = $event)),
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (changeList()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("隐藏")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setting.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "border_top",
                      key: index,
                      onClick: ($event: any) => (setType.value = item.type)
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.lable) + "：", 1),
                        _createVNode(_unref(aRadioGroup), {
                          name: "radioGroup",
                          value: item.value,
                          "onUpdate:value": ($event: any) => ((item.value) = $event),
                          onChange: ($event: any) => (radioChange(item.type, item.value))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.radios, (i, j) => {
                              return (_openBlock(), _createBlock(_unref(aRadio), {
                                key: j + 'only',
                                value: i.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(i.lable), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["value", "onUpdate:value", "onChange"])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_15, [
                        (item.type != 'jump')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_a_button, {
                                class: "mod_modal_btn",
                                style: {"width":"140px"},
                                onClick: ($event: any) => (openModal(item.type))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("我的" + _toDisplayString(item.lable), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_unref(aUpload), {
                                class: "modular_bottom_btn btn_border",
                                "file-list": _unref(fileList),
                                "onUpdate:fileList": _cache[4] || (_cache[4] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                                name: "images",
                                multiple: false,
                                action: "/api/v1/common/upload_images",
                                "before-upload": _unref(beforeUpload),
                                headers: { token: _unref(token) },
                                onChange: _unref(handleChange)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    class: "mod_modal_btn",
                                    style: {"width":"140px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("立即上传")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["file-list", "before-upload", "headers", "onChange"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_a_input, {
                                value: currentItem.value.jump_link,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((currentItem.value.jump_link) = $event)),
                                placeholder: "自定义链接",
                                style: {"width":"195px"}
                              }, null, 8, ["value"]),
                              _createVNode(_component_a_button, {
                                class: "mod_modal_btn",
                                onClick: openLink
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("链接设置")
                                ]),
                                _: 1
                              })
                            ])),
                        _withDirectives(_createElementVNode("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorList), (i, j) => {
                            return (_openBlock(), _createElementBlock("span", {
                              style: _normalizeStyle({ background: i }),
                              key: j,
                              onClick: ($event: any) => ((currentItem.value.bg_color = i), changeList())
                            }, null, 12, _hoisted_19))
                          }), 128))
                        ], 512), [
                          [_vShow, item.type == 'bg']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(currentItem.value.bg_color), 1),
                            _createVNode(_unref(ElColorPicker), {
                              modelValue: currentItem.value.bg_color,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((currentItem.value.bg_color) = $event)),
                              size: "mini",
                              predefine: _unref(colorList)
                            }, null, 8, ["modelValue", "predefine"])
                          ])
                        ], 512), [
                          [_vShow, item.type == 'bg']
                        ])
                      ], 512), [
                        [_vShow, item.type != 'jump' ? item.value == 2 : item.value == 1]
                      ])
                    ], 8, _hoisted_12))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "flex between",
                      key: index
                    }, [
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createVNode(_component_a_input, {
                          value: item.title,
                          "onUpdate:value": ($event: any) => ((item.title) = $event),
                          placeholder: "请输入内容",
                          style: {"width":"180px"},
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (changeList()))
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _createVNode(_component_a_checkbox, {
                        checked: item.title_type,
                        "onUpdate:checked": ($event: any) => ((item.title_type) = $event),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (changeList()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("隐藏")
                        ]),
                        _: 2
                      }, 1032, ["checked", "onUpdate:checked"])
                    ])), [
                      [_vShow, content.value.navType == 5 ? index != 2 : true]
                    ])
                  }), 128))
                ]))
          ]),
          _: 1
        })),
        (_openBlock(), _createBlock(_unref(aTabPane), {
          key: 2,
          tab: "样式设置",
          "force-render": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_unref(aRadioGroup), {
                name: "radioGroup",
                value: content.value.title_type,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((content.value.title_type) = $event)),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (changeContent('title_color', content.value.navType, '')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("默认")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("自定义")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, _toDisplayString(content.value.title_color), 1),
                _createVNode(_unref(ElColorPicker), {
                  modelValue: content.value.title_color,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((content.value.title_color) = $event)),
                  size: "mini",
                  predefine: _unref(colorList),
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (changeContent('title_color', content.value.navType, '')))
                }, null, 8, ["modelValue", "predefine"])
              ])
            ], 512), [
              [_vShow, content.value.title_type == 1]
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radiusType.value, (i, j) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["radius_type flex center", { radius_active: content.value.radius_type == i.type }]),
                    key: j,
                    onClick: ($event: any) => ((content.value.radius_type = i.type), changeContent('radius', content.value.navType, ''))
                  }, _toDisplayString(i.lable), 11, _hoisted_36)), [
                    [_vShow, 
                content.value.navType == 4
                  ? i.type == 1 || i.type == 3
                  : content.value.navType == 5
                  ? i.type == 1 || i.type == 3
                  : i.type == 0 || i.type == 1 || i.type == 2
              ]
                  ])
                }), 128))
              ])
            ])
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(CIconModal, {
      title: `添加${iconTips.value}（只能添加jpg,jpeg,png,大小不超过1MB)`,
      visible: iconVisible.value,
      close: onClose,
      ok: onOK,
      getContainer: () => iconModal.value
    }, null, 8, ["title", "visible", "getContainer"]),
    (linkModal.value)
      ? (_openBlock(), _createBlock(_unref(aModal), {
          key: 0,
          visible: linkModal.value,
          "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((linkModal).value = $event)),
          centered: "",
          title: "链接设置",
          onOk: modalOk
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_unref(aRadioGroup), {
                  options: choiceOptions.value,
                  value: contentSet.value.jump,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((contentSet.value.jump) = $event))
                }, null, 8, ["options", "value"])
              ]),
              (contentSet.value.jump == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_a_select, {
                      class: "line_select",
                      value: contentSet.value.insideLink,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((contentSet.value.insideLink) = $event)),
                      placeholder: "请选择页面",
                      options: pageOptions.value,
                      onChange: getInsideLink
                    }, null, 8, ["value", "options"])
                  ]))
                : _createCommentVNode("", true),
              (contentSet.value.jump == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_a_select, {
                      class: "line_select",
                      value: contentSet.value.inSpecificLink,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((contentSet.value.inSpecificLink) = $event)),
                      "show-search": "",
                      placeholder: '请选择' + pageOptions.value[contentSet.value.insideLink ? contentSet.value.insideLink - 1 : 0].label
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sitePageLinks.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item,
                            value: item.id,
                            label: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "placeholder"])
                  ]))
                : (contentSet.value.jump == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode(_component_a_input, {
                        class: "line_select",
                        placeholder: "请输入外部链接",
                        value: contentSet.value.outsideLink,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((contentSet.value.outsideLink) = $event))
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})